import React, { useState, useEffect } from "react";
import "./locationStats.css";
import Button from "../../../Button/Button";
import PdfImg from "../../../Editor/generisi_pdf.png";
import PictureImg from "./picture/slike.png";
import PictureImg1 from "./picture/slike1.png";
import CommentImg from "./picture/poruke.png";
import ItemImg from "./picture/stavke.png";
import LinkImg from "./picture/linkvi.png";
import DocsImg from "./picture/dokumenta.png";
import NotesImg from "./picture/notes.png";
import FolderImg from "./picture/fascikla.png";
import SearchImg from "./picture/Search.png";

import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";

function LocationStats({ location }) {
    const columns = [
        {
            name: "Email adresa",
            selector: (row) => row.email,
        },
        {
            name: "Datum",
            selector: (row) => row.date,
            sortable: true,
        },
        {
            name: "Ulazak",
            selector: (row) => row.timeEntry,
        },
        {
            name: "Izlazak",
            selector: (row) => row.timeExit || "-",
        },
        {
            name: "Trenutno u sesiji",
            selector: (row) => row.status || "-",
        },
    ];

    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                const response = await axios.post(
                    "https://data.nadzor.app/api/locations/getSessions.php",
                    { location_id: location.location_id }
                );
                if (response.status === 200) {
                    setRecords(response.data);
                } else {
                    console.error("Failed to fetch session data:", response.data.message);
                }
            } catch (error) {
                console.error("Error fetching session data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSessions();
    }, [location.location_id]);

    function handleFilter(event) {
        const keyword = event.target.value.toLowerCase();
        setRecords((prevRecords) =>
            prevRecords.filter(
                (row) =>
                    row.email.toLowerCase().includes(keyword) ||
                    row.date.toLowerCase().includes(keyword) ||
                    row.timeEntry.toLowerCase().includes(keyword) ||
                    row.status.toLowerCase().includes(keyword) ||
                    (row.timeExit && row.timeExit.toLowerCase().includes(keyword))
            )
        );
    }

    const columns2 = [
        {
            name: "Izmenjena stavka",
            selector: (row) => row.item,
        },
        {
            name: "Datum",
            selector: (row) => row.date,
            sortable: true,
        },
        {
            name: "Vreme",
            selector: (row) => row.time,
        },
        {
            name: "Korisnik",
            selector: (row) => row.user,
        },
    ];

    const data2 = [
        {
            id: 1,
            item: "Naslov stavke 1",
            date: "11.12.2024",
            time: "11:45",
            user: "mladendubovac98@gmail.com",
        },
        {
            id: 2,
            item: "Naslov stavke 2",
            date: "11.12.2024",
            time: "11:45",
            user: "dsa@gmail.com",
        },
        {
            id: 3,
            item: "Naslov stavke 3",
            date: "11.12.2024",
            time: "11:45",
            user: "mladendubovac98@gmail.com",
        },
        {
            id: 4,
            item: "Naslov stavke 4",
            date: "11.12.2024",
            time: "11:45",
            user: "ivanivanovic@gmail.com",
        },
    ];

    const [records2, setRecords2] = useState(data2);

    function handleFilter2(event) {
        const keyword = event.target.value.toLowerCase();
        const newData = data2.filter(
            (row) =>
                row.item.toLowerCase().includes(keyword) ||
                row.date.toLowerCase().includes(keyword) ||
                row.time.toLowerCase().includes(keyword) ||
                row.user.toLowerCase().includes(keyword)
        );
        setRecords2(newData);
    }

    const printThePage = () => {
        const page = document.querySelector(".location-stats-wrapper");
        if (page) {
            const printWindow = window.open("", "_blank");
            if (printWindow) {
                printWindow.document.write(`
                    <html>
                    <head>
                        <title>Print Preview</title>
                        <link rel="stylesheet" type="text/css" href="locationStats.css">
                    </head>
                    <body>
                        ${page.outerHTML}
                    </body>
                    </html>
                `);
                printWindow.document.close();
                printWindow.focus();
                printWindow.print();
                printWindow.close();
            }
        } else {
            console.error("Element not found.");
        }
    };

    return (
        <div className="location-stats-wrapper">
            {/* Title  */}
            <div className="location-stats-wrapper-title">
                <h2>{location.location_name} - Statistika</h2>
            </div>

            <div className="basic-info">
                <div className="basic-info-div">
                    <img src={ItemImg} alt="" />
                    <h2>32</h2>
                </div>
                <div className="basic-info-div">
                    <img src={CommentImg} alt="" />
                    <h2>32</h2>
                </div>
                <div className="basic-info-div">
                    <img src={DocsImg} alt="" />
                    <h2>32</h2>
                </div>
                <div className="basic-info-div">
                    <img src={LinkImg} alt="" />
                    <h2>32</h2>
                </div>
                <div className="basic-info-div">
                    <img src={PictureImg} alt="" />
                    <h2>32</h2>
                </div>
            </div>
            <hr />
            <div className="storage">
                <h3>Memorijsko zauzece - 2.5/5GB (50%)</h3>
                <div className="storage-bars">
                    <div className="storage-col">
                        <div className="storage-bar-row">
                            <img src={ItemImg} alt="" />
                            <progress max="100" value="20">20%</progress>
                            <span>20%</span>
                        </div>
                        <div className="storage-bar-row">
                            <img src={DocsImg} alt="" />
                            <progress max="100" value="10">10%</progress>
                            <span>10%</span>
                        </div>
                        <div className="storage-bar-row">
                            <img src={PictureImg1} alt="" />
                            <progress max="100" value="40">40%</progress>
                            <span>40%</span>
                        </div>
                        <div className="storage-bar-row">
                            <img src={FolderImg} alt="" />
                            <progress max="100" value="30">30%</progress>
                            <span>30%</span>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="list-of-entries">
                    <div className="list-of-entries-title">
                        <h3>Listing ulazaka/izlazaka</h3>
                        <div className="text-end">
                            <img src={SearchImg} alt="" />
                            <input type="text" onChange={handleFilter} />
                        </div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={records}
                        fixedHeader
                        progressPending={loading}
                        pagination
                    ></DataTable>
                </div>

                <hr />
                <div className="list-of-edited-items">
                    <div className="list-of-entries-title">
                        <h3>Listing izmena stavki</h3>
                        <div className="text-end">
                            <img src={SearchImg} alt="" />
                            <input type="text" onChange={handleFilter2} />
                        </div>
                    </div>
                    <DataTable
                        columns={columns2}
                        data={records2}
                        fixedHeader
                        pagination
                    ></DataTable>
                </div>
            </div>
        </div>
    );
}

export default LocationStats;
